import type { JourneyCoreState, JourneySpec, JourneyStep } from '../../journey'

export type MarginReportView = 'reports' | 'loading' | 'margin'

export type MarginReportSpotlight = 'vehiculo' | 'comision' | 'total' | null

export interface MarginReportState extends JourneyCoreState {
  view: MarginReportView
  tab: 'stock' | 'margen'
  /** The single "Margen" column has become three. */
  split: boolean
  /** Draws attention to the column that did not exist before. */
  pulseCommission: boolean
  totalsVisible: boolean
  exportToast: boolean
  spotlight: MarginReportSpotlight
}

const INITIAL: MarginReportState = {
  view: 'reports',
  caption: 'Todo comienza en Inicio',
  target: null,
  cursorVisible: true,
  clicking: false,
  clickSeq: 0,
  tab: 'stock',
  split: false,
  pulseCommission: false,
  totalsVisible: false,
  exportToast: false,
  spotlight: null,
}

const build = (): JourneyStep<MarginReportState>[] => [
  // Act 1 — into Reportes, and onto the Margen tab.
  { at: 800, patch: { target: 'navReportes' } },
  { at: 2000, click: true, patch: { caption: 'Entramos a Reportes desde el menú' } },
  { at: 2300, patch: { view: 'loading' } },
  { at: 3100, patch: { view: 'reports', caption: 'Las pestañas de reportes de siempre' } },
  { at: 3800, patch: { target: 'tabMargen' } },
  { at: 5100, click: true, patch: { tab: 'margen', caption: 'Abrimos la pestaña Margen' } },
  { at: 5400, patch: { view: 'loading' } },
  { at: 6100, patch: { view: 'margin', caption: 'Así se veía: un solo margen por negocio' } },
  { at: 6700, patch: { target: 'margenHeader' } },

  // Act 2 — the split, which is the whole announcement.
  {
    at: 8600,
    patch: { split: true, spotlight: 'vehiculo', caption: 'El margen se separa en sus dos componentes' },
  },
  {
    at: 10600,
    patch: { pulseCommission: true, spotlight: 'comision', caption: 'Nueva columna: Comisión de Crédito' },
  },
  {
    at: 13100,
    patch: {
      pulseCommission: false,
      totalsVisible: true,
      spotlight: 'total',
      caption: 'Margen Total: la suma, el mismo total de siempre',
    },
  },

  // Act 3 — the same three columns come down in the spreadsheet.
  { at: 15400, patch: { target: 'export' } },
  { at: 16600, click: true, patch: { caption: 'La planilla de Excel incluye las mismas columnas' } },
  { at: 16900, patch: { exportToast: true } },
  { at: 19500, patch: { spotlight: null, caption: 'Claridad total sobre cada negocio' } },
]

export const marginReportSpec: JourneySpec<MarginReportState> = {
  initial: INITIAL,
  loopMs: 23_000,
  build,
}
